import { Component } from '@angular/core';
import { INoRowsOverlayAngularComp } from '@ag-grid-community/angular';

@Component({
    selector: 'key-value-cell-renderer',
    template: `<span>{{ value }}</span>`
})
export class KeyValueCellRendererComponent implements INoRowsOverlayAngularComp {
    public value: any;

    agInit(params): void {
      if (params.value) {
        const values = params.value.split('|');
        if (values.length === 2) {
          this.value = values[1];
        } else {
          this.value = params.value;  
        }
      } else {
        this.value = '';
      }
    }
}
